<!-- src/app/components/alert/alert.component.html -->
<div class="alert-dialog">
  <div class="alert-header">
    <h2 class="alert-title">{{ data.title }}</h2>
    <button 
      mat-icon-button 
      class="close-button" 
      (click)="onClose()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="alert-content">
    <div class="alert-message" [innerHTML]="data.message"></div>
    <div class="alert-person" *ngIf="data.person as person">
      <img *ngIf="person.photo; else noPhoto" [src]="person.photo" alt="" class="alert-person-photo" />
      <ng-template #noPhoto>
        <div class="alert-person-photo placeholder"><mat-icon>person</mat-icon></div>
      </ng-template>
      <div class="alert-person-info">
        <strong>{{ person.name || 'Unknown name' }}</strong>
        <span *ngIf="person.gmid">{{ person.gmid }}</span>
        <span *ngIf="person.email">{{ person.email }}</span>
      </div>
    </div>
    <details class="alert-details" *ngIf="data.details">
      <summary>More details</summary>
      <pre>{{ data.details }}</pre>
    </details>
  </div>
  
  <div class="alert-actions">
    <!-- Show cancel button only for confirm dialogs -->
    <button 
      *ngIf="data.isConfirm"
      mat-raised-button 
      class="cancel-button"
      (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    
    <button 
      mat-raised-button 
      color="primary" 
      class="confirm-button"
      (click)="onConfirm()"
      cdkTrapFocus>
      {{ data.confirmText }}
    </button>
  </div>
</div>